import H2 from '@oneflare/flarekit/lib/components/H2';
import Label from '@oneflare/flarekit/lib/components/Label';
import Textfield from '@oneflare/flarekit/lib/components/Textfield';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const HelpCenterSearchStyled = styled.section`
  ${media.lgUp`
    padding: 0;
    display: flex;
  `}
`;

export const HelpCenterSearchWrapperStyled = styled.div`
  background-color: ${({ theme }) => theme.color.tin};
  width: 100%;
  padding: 40px 32px;
  border-radius: 8px;
  align-self: flex-start;
  margin: 40px 0 0;
`;

export const HelpCenterSearchTitleStyled = styled(H2)`
  font-family: ${({ theme }) => theme.font.secondaryBold};
  color: ${({ theme }) => theme.color.charcoal};
  font-size: 28px;
  line-height: 1.5;
  margin: 0 0 16px;
`;

export const LabelStyled = styled(Label)`
  font-family: ${({ theme }) => theme.font.primaryRegular};
  color: ${({ theme }) => theme.color.gunMetal};
  font-weight: bold;
`;

export const InputStyled = styled(Textfield)`
  margin-bottom: 24px;
`;
